import { atom } from 'nanostores'

/**
 * Store for Nosto recommendation data
 * Used to share full product data between NostoRecommendationsManager and NostoCuratedRecommendations
 */
export const nostoRecommendationData = atom({})

/**
 * Set recommendation data for a placement
 * @param {string} placementId - The placement ID
 * @param {Object} data - The recommendation data including products with full SKU info
 */
export const setNostoRecommendationData = (placementId, data) => {
    const currentData = nostoRecommendationData.get()
    nostoRecommendationData.set({
        ...currentData,
        [placementId]: data
    })
    console.log(`📦 Stored recommendation data for ${placementId}:`, data)
}

/**
 * Get recommendation data for a placement
 * @param {string} placementId - The placement ID
 * @returns {Object|null} The recommendation data or null if not found
 */
export const getNostoRecommendationData = (placementId) => {
    const data = nostoRecommendationData.get()
    return data[placementId] || null
}

/**
 * Get all recommendation data
 * @returns {Object} All recommendation data
 */
export const getAllNostoRecommendationData = () => {
    return nostoRecommendationData.get()
}

/**
 * Clear all recommendation data
 */
export const clearNostoRecommendationData = () => {
    nostoRecommendationData.set({})
}